import Axios, { AxiosResponse } from "axios";
import store from "@/store";
import { Configuration } from "@/configuration";
import { Project, ProjectInterface } from "@/models/Project";
import { DniTrim } from "@/utils";

export const ErrorHandler = (res: AxiosResponse, data: any) => {
  return data;
};

Axios.defaults.headers["Content-Type"] = "application/json";

Axios.defaults.headers["X-Requested-With"] = "XMLHttpRequest";


export default {
  async informacion_adicional2(empresa_id:number) {
     const informacion = await Axios.get(`${Configuration.api.base}/cotizacion/informacion_adicional/${empresa_id}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
   return informacion.data
  },
  async operacion_credito(empresa_id:number){
      const resp = await Axios.get(`${Configuration.api.base}/operacion/credito/${empresa_id} `, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
      return resp.data.data;
},
async operacion_factoring(empresa_id:number){
    const resp = await Axios.get(`${Configuration.api.base}/operacion/factoring/${empresa_id}`,{
      headers: {
        Authorization: `Bearer ${store.state.token}`
      }
    })
    return resp.data.data;
},
async solicitud_factoring(empresa_id:number){
    const resp = await Axios.get(`${Configuration.api.base}/operacion/solicitudes_factoring/${empresa_id}`,{
      headers: {
        Authorization: `Bearer ${store.state.token}`
      }
    })
   return resp.data;
},
async solicitud_factoringVerDetalle(cotizacion_id:number,empresa_id:number){
    const resp = await 
    Axios.get(`${Configuration.api.base}/operacion/solicitudes_factoring/detalle/${cotizacion_id}/${empresa_id}`,{
      headers: {
        Authorization: `Bearer ${store.state.token}`
      }
    })
    return resp.data;
},
  getEstados() {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/proyecto/estados`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then((res: any) => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getlanding(query: any){
    return new Promise((resolve, reject) => {
      fetch(`${Configuration.api.landing}${query}`)
      .then(response => resolve(response.json()))
      .catch( (err: any) => {
        reject(err)
      })
     /* Axios.get(`${Configuration.api.landing}${query}`
      ).then( (res: any) => {
        resolve(res)
      }).catch( (err: any) => {
        reject(err)
      })*/
    });
  },
  registraranalytics( 
    origen: string,
    ip_address: string,
    variable:string,
    user_id: any,
    empresaid?:any,
    info?:any){
    return new Promise((resolve, reject) => {
      Axios.post(`${Configuration.api.base}/tracking/track-create`,{
        origen,
        ip_address,
        variable,
        user_id,
        empresa_id:empresaid,
        info
      },
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then((res: any) => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },canje(id:any){
    return new Promise((resolve,reject)=>{
      Axios.get(`${Configuration.api.base}/canje/${id}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then((res: any) => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    })
  },
  getGateways() {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/pasarelas`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then((res: any) => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getVIP(id: any) {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/usuario/vip/${id}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then((res: any) => {
          resolve(res.data.message);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  admin: {
    getAllUsers() {
      return new Promise((resolve, reject) => {
        // @ts-ignore
        Axios.get(`${Configuration.api.base}/usuario`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        })
          .then(res => {
            resolve(res.data.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    loginBypass(id: any) {
      return new Promise((resolve, reject) => {
        Axios.post(
          `${Configuration.api.base}/bypassLogin/${id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }
        )
          .then(res => {
            resolve(res.data.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  },
  khipu: {
    confirm: {
      normal(transaction: any) {
        return new Promise((resolve, reject) => {
          Axios.post(
            `${Configuration.api.base}/khipu/confirmar`,
            {
              inversion_id: transaction.inversion_id,
              transaccion_id: transaction.id,
              monto: transaction.monto,
              cod: transaction.cod
            },
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`
              }
            }
          )
            .then(res => {
              resolve(res.data);
            })
            .catch(error => {
              reject(error);
            });
        });
      },
      pending(transaction: any) {
        return new Promise((resolve, reject) => {
          Axios.post(
            `${Configuration.api.base}/khipu/confirmar-pago-pendiente`,
            {
              inversion_id: transaction.inversion_id,
              transaccion_id: transaction.id,
              monto: transaction.monto,
              cod_transaccion: transaction.transaccion,
              pago_deta_tipo_id: transaction.pago_deta_tipo_id,
              cod_inversion: transaction.cod
            },
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`
              }
            }
          )
            .then(res => {
              resolve(res.data);
            })
            .catch(error => {
              reject(error);
            });
        });
      }
    }
  },
  payment: {
    create(payload: any) {
      return new Promise((resolve, reject) => {
        Axios.post(
          `${Configuration.api.base}/transaccion/crear`,
          {
            // @ts-ignore
            user_id: store.state.user.id,
            proyecto_id: payload.projectId,
            motivo: payload.subject,
            // @ts-ignore
            monto: store.state.user.id == 3818 ? 1000 : payload.amount,
            reserva: payload.isReserving,
            socio: payload.isJoiningClub,
            es_socio: payload.isPartner,
            pasarela_id: payload.paymentGateway,
            inversion_id: payload.investmentId,
            pago_deta_tipo_id: payload.paymentType,
            return_url: window.location.origin + "/gracias-por-invertir",
            cancel_url:
              window.location.origin +
              "/panel/inversionista/transferencias-pendientes",
            // @ts-ignore
            payer_email: store.state.user.email,
            // @ts-ignore
            payer_name: store.state.user.nombre + " " + store.state.user.app_pat
          },
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }
        )
          .then(res => {
            resolve(res.data.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    types() {
      return new Promise((resolve, reject) => {
        Axios.get(`${Configuration.api.base}/pagos/detalle/tipos`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        })
          .then(res => {
            resolve(res.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    details(investmentId: number) {
      return new Promise((resolve, reject) => {
        Axios.get(`${Configuration.api.base}/pagos/${investmentId}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        })
          .then(res => {
            resolve(res.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    report: {
      gateway(projectId: number, amount: number, payload: any) {
        return new Promise((resolve, reject) => {
          Axios.post(
            `${Configuration.api.base}/pagos/crear-inversionista`,
            {
              // @ts-ignore
              user_id: store.state.user.id,
              inversion_id: payload.id,
              proyecto_id: projectId,
              monto: amount,
              nombre_titular: payload.name,
              cedula_titular: payload.dni,
              fecha: payload.date,
              pasarela_id: payload.gatewayId,
              cod_transaccion: payload.code,
              pago_deta_tipo_id: 1
            },
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`
              }
            }
          )
            .then(res => {
              resolve(res.data);
            })
            .catch(error => {
              reject(error);
            });
        });
      },
      tracking(tipo: any, id: any) {
        return new Promise((resolve, reject) => {
          Axios.put(
            `${Configuration.api.base}/tracking-inversion/eleccion-pago`,
            {
              tipo: tipo,
              inversion_id: id
            },
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`
              }
            }
          )
            .then(res => {
              resolve(res.data);
            })
            .catch(error => {
              reject(null);
            });
        });
      },
      transference(projectId: number, amount: number, payload: any) {
        return new Promise((resolve, reject) => {
          Axios.post(
            `${Configuration.api.base}/pagos/crear-transferencia-inversionista`,
            {
              // @ts-ignore
              user_id: store.state.user.id,
              proyecto_id: projectId,
              pasarela_id: 1,
              cod_transaccion: payload.cod,
              // monto: amount,
              // @ts-ignore
              monto: store.state.user.id == 3818 ? 1000 : amount,
              inversion_id: payload.investmentId,
              banco_id: payload.bank,
              nro_cuenta: payload.accountNumber,
              nombre_titular: payload.name,
              cedula_titular: payload.dni,
              fecha: payload.date,
              pago_deta_tipo_id: payload.paymentType
            },
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`
              }
            }
          )
            .then(res => {
              resolve(res.data);
            })
            .catch(error => {
              reject(error);
            });
        });
      },
      first_transfer(){
        return new Promise((resolve,reject) => {
          Axios.get(`${Configuration.api.base}/pagos/primera_transferencia`, {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          })
            .then(res => {
              resolve(res);
            })
            .catch(error => {
              reject(error);
            });
        })
      }
    },
    pending: {
      transfer(projectId: number, payload: any) {
        return new Promise((resolve, reject) => {
          Axios.post(
            `${Configuration.api.base}/pagos/crear-transferencia-inversionista`,
            {
              // @ts-ignore
              user_id: store.state.user.id,
              proyecto_id: projectId,
              // @ts-ignore
              monto: store.state.user.id == 3818 ? 1000 : payload.amount,
              // monto: payload.amount,
              inversion_id: payload.investmentId,
              banco_id: payload.bank,
              nro_cuenta: payload.accountNumber,
              nombre_titular: payload.name,
              cedula_titular: payload.dni,
              fecha: payload.date,
              pago_deta_tipo_id: payload.paymentType
            },
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`
              }
            }
          )
            .then(res => {
              resolve(res.data);
            })
            .catch(error => {
              reject(error);
            });
        });
      },
      gateway(payload: any) {
        return new Promise((resolve, reject) => {
          Axios.post(
            `${Configuration.api.base}/transaccion/crear-pago-pendiente-khipu`,
            {
              inversion_id: payload.investmentId,
              monto: payload.amount,
              pago_deta_tipo_id: payload.paymentType,
              transaccion: payload.transaction,
              motivo: payload.subject,
              return_url: window.location.origin + "/gracias-por-invertir",
              cancel_url: window.location.origin + "/pago-erroneo",
              // @ts-ignore
              payer_email: store.state.user.email,
              // @ts-ignore
              payer_name:
                // @ts-ignore
                store.state.user.nombre + " " + store.state.user.app_pat
            },
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`
              }
            }
          )
            .then(res => {
              resolve(res.data);
            })
            .catch(error => {
              reject(error);
            });
        });
      }
    },
    emails: {
      primeraTransferencia(id_transfer:any){
          return new Promise((resolve, reject) => {
            Axios.get(
              `${Configuration.api.base}/pagos/primera_transferencia_mail/${id_transfer}`,
              {
                headers: {
                  Authorization: `Bearer ${store.state.token}`
                }
              }
            )
              .then(res => {
                resolve(res);
              })
              .catch(error => {
                reject(error);
              });
          });
      },
      transferenciaMayorCincoMM(id_transfer:any){
        return new Promise((resolve, reject) => {
          Axios.get(
            `${Configuration.api.base}/pagos/transferencia_5_m_mail/${id_transfer}`,
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`
              }
            }
          )
            .then(res => {
              resolve(res);
            })
            .catch(error => {
              reject(error);
            });
        });
    }
      
    }
  },
  investment: {
    normal(paymentId: number) {
      return new Promise((resolve, reject) => {
        Axios.get(`${Configuration.api.base}/inversion/${paymentId}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        })
          .then(res => {
            resolve(res.data.data);
          })
          .catch(error => {
            reject(error.response);
          });
      });
    },
    pending(paymentId: number) {
      return new Promise((resolve, reject) => {
        Axios.get(`${Configuration.api.base}/inversion/${paymentId}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        })
          .then(res => {
            resolve(res.data);
          })
          .catch(error => {
            reject(error.response);
          });
      });
    },
    temporal: {
      create() {},
      delete() {},
      all() {}
    },
    initial: {
      create() {},
      all() {}
    },
    all() {}
  },
  user: {
    account: {
      get() {},
      update() {},
      password: {
        update() {}
      }
    },
    terms: {
      get() {}
    }
  },
  dashboard: {
    montoTotalInvertido() {
      return new Promise((resolve, reject) => {
        // @ts-ignore
        Axios.get(
          // @ts-ignore
          `${Configuration.api.base}/estadisticas/montoTotalInvertido/${store.state.user.id}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }
        )
          .then(res => {
            resolve(res.data.data.monto_invertido);
          })
          .catch(error => {
            reject(null);
          });
      });
    },
    montoTotalRecibidoProyectoCerrado() {
      return new Promise((resolve, reject) => {
        // @ts-ignore
        Axios.get(
          // @ts-ignore
          `${Configuration.api.base}/estadisticas/montoTotalRecibidoProyectoCerrado/${store.state.user.id}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }
        )
          .then(res => {
            resolve(res.data.data);
          })
          .catch(error => {
            reject(null);
          });
      });
    },
    montoTotalInvertidoPendienteDePago() {
      return new Promise((resolve, reject) => {
        // @ts-ignore
        Axios.get(
          // @ts-ignore
          `${Configuration.api.base}/estadisticas/montoTotalInvertidoPendienteDePago/${store.state.user.id}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }
        )
          .then(res => {
            resolve(res.data.data.monto_invertido);
          })
          .catch(error => {
            reject(null);
          });
      });
    },
    rentabilidadProyectosPagadosCerrados() {
      return new Promise((resolve, reject) => {
        // @ts-ignore
        Axios.get(
          // @ts-ignore
          `${Configuration.api.base}/estadisticas/rentabilidadProyectosPagadosCerrados/${store.state.user.id}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }
        )
          .then(res => {
            resolve(res.data.data);
          })
          .catch(error => {
            reject(null);
          });
      });
    },
    rentabilidadProyectosMoraMayor180DiasImpagas() {
      return new Promise((resolve, reject) => {
        // @ts-ignore
        Axios.get(
          // @ts-ignore
          `${Configuration.api.base}/estadisticas/rentabilidadProyectosMoraMayor180DiasImpagas/${store.state.user.id}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }
        )
          .then(res => {
            resolve(res.data.data);
          })
          .catch(error => {
            reject(null);
          });
      });
    },
    totalMontosInvertidoProyectosActivos() {
      return new Promise((resolve, reject) => {
        // @ts-ignore
        Axios.get(
          // @ts-ignore
          `${Configuration.api.base}/estadisticas/totalMontosInvertidoProyectosActivos/${store.state.user.id}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }
        )
          .then(res => {
            resolve(res.data.data.monto);
          })
          .catch(error => {
            reject(null);
          });
      });
    },
    montoInvertidoEnMora() {
      return new Promise((resolve, reject) => {
        // @ts-ignore
        Axios.get(
          // @ts-ignore
          `${Configuration.api.base}/estadisticas/montoInvertidoEnMora/${store.state.user.id}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }
        )
          .then(res => {
            resolve(res.data.data.monto);
          })
          .catch(error => {
            reject(null);
          });
      });
    },
    montoEnMora180Dias() {
      return new Promise((resolve, reject) => {
        // @ts-ignore
        Axios.get(
          // @ts-ignore
          `${Configuration.api.base}/estadisticas/montoEnMora180Dias/${store.state.user.id}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }
        )
          .then(res => {
            resolve(res.data.data.monto);
          })
          .catch(error => {
            reject(null);
          });
      });
    },
    tasaMontoEnMora180Dias() {
      return new Promise((resolve, reject) => {
        // @ts-ignore
        Axios.get(
          // @ts-ignore
          `${Configuration.api.base}/estadisticas/tasaMontoEnMora180Dias/${store.state.user.id}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }
        )
          .then(res => {
            resolve(res.data.data);
          })
          .catch(error => {
            reject(null);
          });
      });
    }
  },
  // START ESTADISTICAS
  getTotalAmountInvested() {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.base}/montoTotalInvertido/${store.state.user.id}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getTotalAmountInvestedFromClosedProjects() {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.base}/montoTotalInvertidoProyectoCerrado/${store.state.user.id}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getTotalAmountReceivedFromClosedProjects() {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.base}/montoTotalRecibidoProyectoCerrado/${store.state.user.id}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getTotalUtilityEarnedFromClosedProjects() {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.base}/gananciaTotalProyectoCerrado/${store.state.user.id}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getRateOfThreeMonths() {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.base}/montosMoraTresMeses/${store.state.user.id}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getRateOfSixMonths() {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.base}/montosMoraSeisMeses/${store.state.user.id}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data.data.monto_mora);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getRateOfThirtyDays() {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.base}/vencimientoTreintaDias/${store.state.user.id}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data.data.monto_por_vencer);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getRateOfSixtyDays() {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.base}/vencimientoSesentaDias/${store.state.user.id}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data.data.monto_por_vencer);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getBeatenRate() {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.base}/montoVencidoMora/${store.state.user.id}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data.data.monto_vencido_mora);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getBeatenBalance() {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.base}/saldoInsoluto/${store.state.user.id}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  // END ESTADISTICAS
  getAmounts() {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/montos`)
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },
  getTransferences() {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.base}/transferencias/${store.state.user.id}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getInitialInvestments(projectId: any) {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.base}/inversiones/iniciales/${store.state.user.id}/${projectId}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createInitialInvestment(payload: any) {
    return new Promise((resolve, reject) => {
      Axios.post(
        `${Configuration.api.base}/inversiones/crear`,
        {
          // @ts-ignore
          user_id: store.state.user.id,
          proyecto_id: payload.projectId,
          // @ts-ignore
          monto: store.state.user.id == 3818 ? 1000 : payload.amount,
          // inversion: payload.investment,
          reserva: payload.isReserving,
          cancelando_socio: payload.isCancellingClub,
          es_socio: payload.isPartner,
          socio: payload.isJoiningClub,
          inversion_tmp_id: payload.investmentId,
          cod_inversion: payload.code
        },
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getTemporalInvestmentsByUserId() {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.base}/inversion-tmp/listado/${store.state.user.id}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getTemporalInvestments(projectId: any) {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.base}/inversion-tmp/listado/${store.state.user.id}/${projectId}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createTemporalInvestment(tmp: any) {
    return new Promise((resolve, reject) => {
      Axios.post(
        `${Configuration.api.base}/inversion-tmp/crear`,
        {
          // @ts-ignore
          user_id: store.state.user.id,
          proyecto_id: tmp.project_id,
          // @ts-ignore
          monto: store.state.user.id == 3818 ? 1000 : tmp.amount
        },
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteTemporalInvestments(projectId: number) {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.delete(`${Configuration.api.base}/inversion-tmp/eliminar`, {
        data: {
          // @ts-ignore
          user_id: store.state.user.id,
          proyecto_id: projectId
        },
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getClub() {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(`${Configuration.api.base}/socio/${store.state.user.id}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getSecretProjects(): Promise<Array<Project>> {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(`${Configuration.api.base}/secretos/${store.state.user.id}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          let projects: Array<ProjectInterface> = res.data.data.proyectos;
          resolve(projects.map(project => new Project(project)));
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getProjects(data: any): Promise<Array<Project>> {
    return new Promise((resolve, reject) => {
      Axios.post(
        `${Configuration.api.base}/filtrado`,
        {
          factura: data.factura ? 1 : 0,
          credito: data.credito ? 1 : 0,
          tasa: data.tasa,
          cuota: data.cuota,
          offset: data.offset
        },
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          let projects: Array<ProjectInterface> = res.data;
          if (process.env.VUE_APP_API_ENV == "development") {
            resolve(projects.map(project => new Project(project)));
          } else {
            resolve(
              projects
                .map(project => new Project(project))
                .filter(pro => pro.id != 1)
            );
          }
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getStatistics(projectId: number) {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/proyectoEstadistica/${projectId}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getProject(projectId: number): Promise<ProjectInterface> {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/proyecto/${projectId}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          let project: ProjectInterface = res.data.data;
          // @ts-ignore
          resolve(new Project(project));
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getSecretProject(projectId: number): Promise<ProjectInterface> {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/proyecto/secreto/${projectId}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          let project: ProjectInterface = res.data.data;
          // @ts-ignore
          resolve(new Project(project));
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  addProjectView(projectId: number) {
    return new Promise((resolve, reject) => {
      Axios.post(`${Configuration.api.base}/proyecto/visita`, {
        proyecto_id: projectId
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getProjectAmounts(projectId: number) {
    return new Promise((resolve, reject) => {
      Axios.get(
        `${Configuration.api.base}/proyecto-montos-total/${projectId}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  simulate(projectId: number, amount: number, last: any, id?: any) {
    return new Promise((resolve, reject) => {
      Axios.post(
        `${Configuration.api.base}/simular`,
        {
          proyecto_id: projectId,
          monto: amount,
          user: id,
          ultimo: last
        },
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  login(rut: string, password: string, documento:string) {
    return new Promise((resolve, reject) => {
      Axios.post(`${Configuration.api.base}/login`, {
        rut: DniTrim.string(rut),
        password: password,
        tipo_documento_id:documento
      })
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  async login2fa(code: string, temp_token: string) {
      const formData = new FormData();
      formData.append('code', code);
      formData.append('temp_token', temp_token);
      
      return await Axios.post(`${Configuration.api.base}/validar_2FA`, formData);

  },
  register(
    nombre: string,
    app_pat: string,
    email: string,
    tipo_doc:string,
    password: string,
    c_password: string,
    dni: string,
    via_id:number,
    telefono?: string,
    user_tipo_id?: number
  ) {
    return new Promise((resolve, reject) => {
      Axios.post(`${Configuration.api.base}/register`, {
        nombre: nombre,
        app_pat: app_pat,
        email: email,
        tipo_documento_id:tipo_doc,
        password: password,
        c_password: c_password,
        rut: DniTrim.string(dni),
        via_id: via_id,
        telefono: telefono,
        user_tipo_id: user_tipo_id
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },
  logout() {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/logout`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getBanks() {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/banco`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getAccountTypes() {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/bancos/tipos`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getCompany(companyId: number) {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/empresa/${companyId}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getCountries() {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/pais`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getRegions(countryId?: number) {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/region`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          if (countryId == undefined) {
            resolve(res.data.data);
          } else {
            resolve(res.data.data.filter((el: any) => el.pais_id == countryId));
          }
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getCommunes(regionId: number) {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/comuna/region/${regionId}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  async listar_clasificaciones(){
    const listar_clasificaciones =await Axios.get(`${Configuration.api.base}/listar_clasificaciones`,
    { 
      headers: { 
        Authorization: `Bearer ${store.state.token}`
      } 
    })
    return listar_clasificaciones.data
  },
  async getClasificacion(id:any){
    const getClasificacion =await Axios.get(`${Configuration.api.base}/getClasificacion/${id}`,
    { 
      headers: { 
        Authorization: `Bearer ${store.state.token}`
      } 
    })
    return getClasificacion.data
  },
  contact(name: string, mail: string, telefono: string, message: string, clasificacion_id? : number,dato_adicional? :any, origen_reclamo?:any) {
    return new Promise((resolve, reject) => {
      Axios.post(
        `${Configuration.api.base}/contacto`,
        {
          nombre: name,
          mail: mail,
          telefono,
          mensaje: message,
          clasificacion_id,
          dato_adicional,
          origen_reclamo,
        },
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          resolve(error.response.data);
        });
    });
  },
  recover(token:string,rut: string) {
    return new Promise((resolve, reject) => {
      Axios.post(
        `${Configuration.api.base}/password/create`,
        {
          "g-recaptcha-response":token,
          rut
        },
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },
  newPassword(
    rut: string,
    password: string,
    c_password: string,
    token: string
  ) {
    return new Promise((resolve, reject) => {
      Axios.post(
        `${Configuration.api.base}/password/reset`,
        {
          rut: DniTrim.string(rut),
          password: password,
          c_password: c_password,
          token: token,
        },
        {
          headers: {}
        }
      )
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    });
  },
  credit(creditPayload: any) {
    return new Promise((resolve, reject) => {
      Axios.post(
        `${Configuration.api.base}/credito/solicitar`,
        {
          rut: DniTrim.string(creditPayload.rut),
          empresa: creditPayload.name,
          telefono: creditPayload.phone,
          email: creditPayload.email,
          credito_necesidad_id: creditPayload.needSelected,
          credito_venta_id: creditPayload.salesSelected,
          credito_garantia_id: creditPayload.propertyWarrantySelected,
          credito_objetivo_id: creditPayload.averageSelected,
          deuda: creditPayload.debt,
          propiedad: creditPayload.propertyCost,
          propiedad_deuda: creditPayload.propertyDebt,
          propiedad_tipo: creditPayload.propertyWarrantySelected
        },
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getDuenosbusiness(empresa_id: any){
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/empresa_dueno/${empresa_id}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createBusiness(payload: any) {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      const formData = new FormData();
      Object.entries(payload).forEach(([key, value]) => {
        if (key === 'doc_files') {
          //@ts-ignore
          Object.entries(value).forEach(([fileKey, file]) => {
            if (file instanceof File) {
              formData.append(`doc_files[${fileKey}]`, file);
            }
          });
        } else {
          // Convierte todos los valores a string antes de agregar
          //@ts-ignore
          formData.append(key, value != null ? value.toString() : '');
        }
      });

      Axios.post(`${Configuration.api.base}/empresa`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${store.state.token}`
        }
        /* onUploadProgress: callback, */
      })
        .then((res: any) => {
          resolve(res.data.data);
        })
        .catch((error: any) => {
          reject(error.response);
        });
    });
  },
  stateBusiness(empresa_id:any){
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/empresa_estado/${empresa_id}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  closedstateBusiness(empresa_id:any){
    return new Promise((resolve, reject) => {
      Axios.post(`${Configuration.api.base}/cerrar_solicitud/${empresa_id}`,{} ,{
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createsolicitud(empresa_id:any, 
        nombre: string,
        rut: string,
        descripcion: string,
        telefono: string,
        direccion: string,
        empresa_target_id: string,
        tiempo_experiencia: string,
        sc_3:number,
        tiempo_local: string,
        sc_4:number,
        a_quien_vendes: string,
        sc_8: string,
        deuda_sin_hipoteca: string,
        deuda_hoy: string,
        alguna_hipoteca: string,
        clavesii?: string,
        razon_social?: string,
        giro?: number,
        web?: string,
        fecha_inicio_actividades?: string,
        categoria?:any,
        tramo_id?:number,
        cant_trabajadores?:number,
        proveedores_comuna?:string,
        region_id?:number,
        comuna_id?:number,
        pais_id?:number,){
    return new Promise((resolve, reject) => {
      Axios.post(`${Configuration.api.base}/crear_solicitud/${empresa_id}`,{
        // @ts-ignore
        user_id: store.state.user.id,
        nombre,
        rut,
        descripcion,
        telefono,
        direccion,
        empresa_target_id,
        tiempo_experiencia,
        sc_3,
        tiempo_local,
        sc_4,
        a_quien_vendes,
        sc_8,
        deuda_sin_hipoteca,
        deuda_hoy,
        alguna_hipoteca,
        clavesii,
        razon_social,
        giro,
        web,
        fecha_inicio_actividades,
        categoria,
        cant_trabajadores,
        proveedores_comuna,
        tramo_id,
        region_id,
        comuna_id,
        pais_id,
      } ,{
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  empresadueno(empresa_id:any){
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/empresa_dueno/${empresa_id}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  editCompany(company: any) {
    let excludes = [
        "id",
        "ejecutivo_id",
        "credito_venta_id",
        "imagen_id",
        "fecha_creacion",
        "deuda",
        "afecto_iva",
        "carpeta"
    ];

    let payload: any = {};

    for (let key in company) {
        if (key.endsWith("ed_at") || excludes.includes(key)) continue;

        payload[key] = company[key];
    }

    return Axios.put(`${Configuration.api.base}/empresa/${company.id}`, payload, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
      .then(() => {
          return true;
      });
  },
  requestsByCompanyId(empresa_id: number) {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/solicitudes-empresa/${empresa_id}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  projectsByCompanyId(empresa_id: number) {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/proyectos-empresa/${empresa_id}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  request: {
    factoring(empresa_id: string, facturas: any[]) {
      return new Promise((resolve, reject) => {
        let payload: any = {
          // @ts-ignore
          user_id: store.state.user.id,
          empresa_id,
          facturas
        };
        Axios.post(`${Configuration.api.base}/solicitud/factoring`, payload, {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        })
          .then(res => {
            resolve(res.data.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    credit(
      empresa_id: string,
      motivo: string,
      monto: string,
      plazo: number,
      garantia: any
    ) {
      return new Promise((resolve, reject) => {
        let payload: any = {
          // @ts-ignore
          user_id: store.state.user.id,
          empresa_id,
          motivo,
          monto,
          plazo
        };

        if (garantia != null) {
          payload["garantia"] = garantia;
        }

        Axios.post(`${Configuration.api.base}/solicitud/credito`, payload, {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        })
          .then(res => {
            resolve(res.data.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    leaseback(
      empresa_id: string,
      motivo: string,
      monto: string,
      plazo: number,
      garantia?: any
    ) {
      return new Promise((resolve, reject) => {
        Axios.post(
          `${Configuration.api.base}/solicitud/leaseback`,
          {
            // @ts-ignore
            user_id: store.state.user.id,
            empresa_id,
            motivo,
            monto,
            plazo,
            garantia
          },
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }
        )
          .then(res => {
            resolve(res.data.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    accion(
      empresa_id: string,
      motivo: string,
      monto: string,
      plazo: number,
      garantia: any,
      accion_pyme_id?: any
    ) {
      return new Promise((resolve, reject) => {
        let payload: any = {
          // @ts-ignore
          user_id: store.state.user.id,
          empresa_id,
          motivo,
          monto,
          plazo,
          accion_pyme_id
        };

        Axios.post(`${Configuration.api.base}/solicitud/credito`, payload, {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        })
          .then(res => {
            resolve(res.data.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    }
  },
  requestCredit(
    empresa_id: string,
    type_id: string,
    rut: string,
    monto: number,
    nombre: string,
    plazo: number,
    garantia_id?: number,
    motivo?: string
  ) {
    return new Promise((resolve, reject) => {
      let payload: any = {
        // @ts-ignore
        user_id: store.state.user.id,
        empresa_id: empresa_id,
        tipo_id: type_id,
        rut,
        garantia_id,
        monto,
        nombre,
        plazo,
        motivo
        // facturas: [
        //   {
        //     folio,
        //     rut,
        //     monto,
        //     nombre,
        //     plazo,
        //   },
        // ],
        // garantia: {
        //   monto,
        //   garantia_id,
        //   plazo,
        //   valor_garantia,
        //   deuda_garantia,
        // }
      };

      Axios.post(`${Configuration.api.base}/solicitud`, payload, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },
  getMyInvestments(): Promise<Array<any>> {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.base}/inversiones/${store.state.user.id}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data.data[0]);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getMyStates(): Promise<Array<any>> {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.base}/inversiones/${store.state.user.id}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data.data[1]);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getUserBank() {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.base}/usuario/banco/id`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          if (res.data.data.cuenta_bancaria != null) {
            resolve(res.data.data.cuenta_bancaria);
          } else {
            reject(null);
          }
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  updateBankAccount(
    accountNumber: string,
    bank_id: number,
    bankAccountType: number
  ) {
    return new Promise((resolve, reject) => {
      Axios.post(
        `${Configuration.api.base}/usuario/banco`,
        {
          // @ts-ignore
          numero: accountNumber,
          banco_id: bank_id,
          tipo_cuenta_id: bankAccountType
        },
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve({
            message: "ok"
          });
        })
        .catch(error => {
          reject({
            error
          });
        });
    });
  },
  getPendingPayments(): Promise<Array<any>> {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.base}/inversiones/${store.state.user.id}/pendiente`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          let payments: Array<any> = res.data.data;
          resolve(payments);
        })
        .catch(error => {
          reject([]);
        });
    });
  },
  AnularPendingPayments(id:any,comentarios:any){
      return new Promise((resolve, reject)=>{
        Axios.post(`${Configuration.api.base}/inversiones/inversionista_anula`, {
          inversion_proyecto_id: id,
          texto:comentarios
        }, {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }).then(res=>{
          resolve(res)
        }).catch(error => {reject(error)})
      })
  },
  getCancelPayments(){
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.base}/inversionista_anulaciones`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          let payments: Array<any> = res.data.data;
          resolve(payments);
        })
        .catch(error => {
          reject([]);
        });
    });
  },
  async detalle_cuotas(){
    let detalle_cuotas = await Axios.get(`${Configuration.api.base}/detalle_cuotas`,{
      headers: {
        Authorization: `Bearer ${store.state.token}`
      }
    })
    return detalle_cuotas.data
  },
  documents: {
    contracts() {
      return new Promise((resolve, reject) => {
        // @ts-ignore
        Axios.get(
          // @ts-ignore
          `${Configuration.api.base}/documentos/${store.state.user.id}/contratos`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }
        )
          .then(res => {
            if (res.data.errors != undefined) {
              resolve([]);
            } else {
              resolve(res.data.data.contratos);
            }
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    
    terms() {
      return new Promise((resolve, reject) => {
        // @ts-ignore
        Axios.get(
          // @ts-ignore
          `${Configuration.api.base}/documentos/${store.state.user.id}/mandatos`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }
        )
          .then(res => {
            if (res.data.errors != undefined) {
              resolve([]);
            } else {
              resolve(res.data.data.contratos);
            }
          })
          .catch(error => {
            reject(null);
          });
      });
    },
    ious() {
      return new Promise((resolve, reject) => {
        // @ts-ignore
        Axios.get(
          // @ts-ignore
          `${Configuration.api.base}/documentos/${store.state.user.id}/pagares`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }
        )
          .then(res => {
            if (res.data.errors != undefined) {
              resolve([]);
            } else {
              resolve(res.data.data.contratos);
            }
          })
          .catch(error => {
            reject(null);
          });
      });
    }
  },
  getUniqueCode() {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/codigo`).then(res => {
        resolve(res.data);
      });
    });
  },
  updatePersonalData(user: any) {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.put(
        // @ts-ignore
        `${Configuration.api.base}/usuario/${store.state.user.id}`,
        user,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getPersonalData(userId: number) {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/usuario/${userId}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  changePassword(
    oldPassword: string,
    newPassword: string,
    confirmPassword: string
  ) {
    return new Promise((resolve, reject) => {
      Axios.post(
        `${Configuration.api.base}/usuario/password`,
        {
          password: oldPassword,
          password_new: newPassword,
          password_c: confirmPassword
        },
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getBusiness() {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.base}/empresa/usuario/${store.state.user.id}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data.data.empresas_usuario);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getBusiness2(user_id:any) {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/empresa/usuario/${user_id}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data.data.empresas_usuario );
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getQuote(amount: number, month: number) {
    return new Promise((resolve, reject) => {
      Axios.post(
        `${Configuration.api.base}/simulacion/accion`,
        {
          capital: amount,
          tiempo_meses: month
        },
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  actionSimulate(simulate: any) {
    return new Promise((resolve, reject) => {
      Axios.post(
        `${Configuration.api.base}/simulacion/accion/email`,
        {
          monto: simulate.amount,
          email: simulate.mail,
          cuota: simulate.quote,
          plazo: simulate.month,
          tasa_interes: simulate.tasa_interes
        },
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  simulate_day(ip:any){
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/tracking/simular_dia/${ip}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  landing: {
    chilecompra(
      name: string,
      mail: string,
      message: string,
      phone: string,
      rut_empresa: any,
      nombre_empresa: any
    ) {
      return new Promise((resolve, reject) => {
        Axios.post(
          `${Configuration.api.base}/landing/chilecompra`,
          {
            nombre: name,
            mail: mail,
            rut_empresa: DniTrim.string(rut_empresa),
            nombre_empresa: nombre_empresa,
            mensaje: message,
            telefono: phone
          },
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }
        )
          .then(res => {
            resolve(res.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    landing(name: string, mail: string, phone: string, via: string) {
      return new Promise((resolve, reject) => {
        Axios.post(`${Configuration.api.base}/landingcrm`, {
          nombre: name,
          email: mail,
          telefono: phone,
          via: via
        })
          .then(res => {
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    santander(
      name: string,
      lastname: string,
      dni: any,
      businessName: string,
      businessDni: any,
      mail: string,
      landing: string,
      via: string,
      phone?: string,
      amount?: number,
      comment?: string
    ) {
      return new Promise((resolve, reject) => {
        Axios.post(`${Configuration.api.base}/landingSolicitantes`, {
          nombre: name,
          apellido: lastname,
          rut: DniTrim.string(dni),
          nombre_empresa: businessName,
          rut_empresa: DniTrim.string(businessDni),
          telefono: phone,
          email: mail,
          landing: landing,
          via: via,
          monto_factura: amount,
          comentario_banco: comment
        })
          .then(res => {
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    bcp(
      name: string,
      lastname: string,
      dni: any,
      businessName: string,
      businessDni: any,
      mail: string,
      landing: string,
      via: string,
      phone?: string,
      amount?: number,
      comment?: string
    ) {
      return new Promise((resolve, reject) => {
        Axios.post(`${Configuration.api.base}/landingSolicitantes`, {
          nombre: name,
          apellido: lastname,
          rut: DniTrim.string(dni),
          nombre_empresa: businessName,
          rut_empresa: DniTrim.string(businessDni),
          telefono: phone,
          email: mail,
          landing: landing,
          via: via,
          monto_factura: amount,
          comentario_banco: comment
        })
          .then(res => {
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    banigualdad(
      name: string,
      lastname: string,
      dni: any,
      businessName: string,
      businessDni: any,
      mail: string,
      landing: string,
      via: string,
      phone?: string,
      amount?: number,
      comment?: string
    ) {
      return new Promise((resolve, reject) => {
        Axios.post(`${Configuration.api.base}/landingSolicitantes`, {
          nombre: name,
          apellido: lastname,
          rut: DniTrim.string(dni),
          nombre_empresa: businessName,
          rut_empresa: DniTrim.string(businessDni),
          telefono: phone,
          email: mail,
          landing: landing,
          via: via,
          monto_factura: amount,
          comentario_banco: comment
        })
          .then(res => {
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  },
  customContact(
    name: string,
    mail: string,
    message: string,
    phone: string,
    rut_empresa: any,
    nombre_empresa: any,
    landing: any,
    type: any
  ) {
    return new Promise((resolve, reject) => {
      Axios.post(
        `${Configuration.api.base}/landing`,
        {
          nombre: name,
          mail: mail,
          rut_empresa: DniTrim.string(rut_empresa),
          nombre_empresa: nombre_empresa,
          mensaje: message,
          telefono: phone,
          landing: landing,
          clasificacion_id: type
        },
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },
  chilecompra(
    name: string,
    mail: string,
    message: string,
    phone: string,
    type: any
  ) {
    return new Promise((resolve, reject) => {
      Axios.post(
        `${Configuration.api.base}/contacto`,
        {
          nombre: name,
          mail: mail,
          mensaje: message,
          telefono: phone,
          clasificacion_id: type
        },
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },
  scheduleCall(message: string, phone: string) {
    return new Promise((resolve, reject) => {
      Axios.post(
        `${Configuration.api.base}/contacto`,
        {
          // @ts-ignore
          nombre: `${store.state.user.nombre} ${store.state.user.app_pat}`,
          // @ts-ignore
          mail: store.state.user.email,
          mensaje: message,
          telefono: phone,
          clasificacion_id: 1
        },
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          resolve(error.response.data);
        });
    });
  },
  declarationes(user_id:number){
    return new Promise((resolve,reject)=>{
      Axios.get(`${Configuration.api.base}/documentos/${user_id}/declaraciones`,{
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    })
  },
  declaration(user_id:number, anio:any){
    return new Promise((resolve,reject)=>{
      Axios.get(`${Configuration.api.base}/documentos/${user_id}/declaracion/${anio}`,{
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    })
  },
  accion: {
    eleven: {
      howMuch() {
        return new Promise((resolve, reject) => {
          // @ts-ignore
          Axios.get(`${Configuration.api.base}/cuanto_vendes`, {})
            .then(res => {
              resolve(res.data.data);
            })
            .catch(error => {
              reject(null);
            });
        });
      },
      anualSales() {
        return new Promise((resolve, reject) => {
          // @ts-ignore
          Axios.get(`${Configuration.api.base}/ventas_anio_anterior`, {})
            .then(res => {
              resolve(res.data.data);
            })
            .catch(error => {
              reject(null);
            });
        });
      },
      nextYear() {
        return new Promise((resolve, reject) => {
          // @ts-ignore
          Axios.get(`${Configuration.api.base}/proximo_anio`, {})
            .then(res => {
              resolve(res.data.data);
            })
            .catch(error => {
              reject(null);
            });
        });
      },
      ifYouHave() {
        return new Promise((resolve, reject) => {
          // @ts-ignore
          Axios.get(`${Configuration.api.base}/disponible_millones`, {})
            .then(res => {
              resolve(res.data.data);
            })
            .catch(error => {
              reject(null);
            });
        });
      },
      debts() {
        return new Promise((resolve, reject) => {
          // @ts-ignore
          Axios.get(`${Configuration.api.base}/deuda_hoy`, {})
            .then(res => {
              resolve(res.data.data);
            })
            .catch(error => {
              reject(null);
            });
        });
      },
      toWho() {
        return new Promise((resolve, reject) => {
          // @ts-ignore
          Axios.get(`${Configuration.api.base}/a_quien_debes`, {})
            .then(res => {
              resolve(res.data.data);
            })
            .catch(error => {
              reject(null);
            });
        });
      },
      houseDebt() {
        return new Promise((resolve, reject) => {
          // @ts-ignore
          Axios.get(`${Configuration.api.base}/credito_hipotecario`, {})
            .then(res => {
              resolve(res.data.data);
            })
            .catch(error => {
              reject(null);
            });
        });
      },
      amountDebt() {
        return new Promise((resolve, reject) => {
          // @ts-ignore
          Axios.get(`${Configuration.api.base}/cuanto_debe_total`, {})
            .then(res => {
              resolve(res.data.data);
            })
            .catch(error => {
              reject(null);
            });
        });
      },
      ifGetCredit() {
        return new Promise((resolve, reject) => {
          // @ts-ignore
          Axios.get(`${Configuration.api.base}/credito_disponible`, {})
            .then(res => {
              resolve(res.data.data);
            })
            .catch(error => {
              reject(null);
            });
        });
      },
      ifGetGifted() {
        return new Promise((resolve, reject) => {
          // @ts-ignore
          Axios.get(`${Configuration.api.base}/te_regalan`, {})
            .then(res => {
              resolve(res.data.data);
            })
            .catch(error => {
              reject(null);
            });
        });
      },
      dreamingCredit() {
        return new Promise((resolve, reject) => {
          // @ts-ignore
          Axios.get(`${Configuration.api.base}/elegir_credito`, {})
            .then(res => {
              resolve(res.data.data);
            })
            .catch(error => {
              reject(null);
            });
        });
      },
      updateData(payload: any) {
        return new Promise((resolve, reject) => {
          // @ts-ignore
          Axios.put(
            // @ts-ignore
            `${Configuration.api.base}/usuario/${store.state.user.id}`,
            payload,
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`
              }
            }
          )
            .then(res => {
              resolve(res.data);
            })
            .catch(error => {
              reject(null);
            });
        });
      },
      business(
        nombre: string,
        rut: string,
        descripcion: string,
        telefono: string,
        direccion: string,
        empresa_target_id: string,
        tiempo_experiencia: string,
        sc_3:number,
        tiempo_local: string,
        sc_4:number,
        a_quien_vendes: string,
        sc_8: string,
        deuda_sin_hipoteca: string,
        deuda_hoy: string,
        alguna_hipoteca: string,
        clavesii?: string,
        razon_social?: string,
        giro?: number,
        web?: string,
        fecha_inicio_actividades?: string,
        categoria?:any,
        tramo_id?:number,
        cant_trabajadores?:number,
        proveedores_comuna?:string,
        region_id?:number,
        comuna_id?:number,
        pais_id?:number,
      ) {
        return new Promise((resolve, reject) => {
          // @ts-ignore
          Axios.post(
            `${Configuration.api.base}/empresa`,
            {
              // @ts-ignore
              user_id: store.state.user.id,
              nombre,
              rut,
              descripcion,
              telefono,
              direccion,
              empresa_target_id,
              tiempo_experiencia,
              sc_3,
              tiempo_local,
              sc_4,
              a_quien_vendes,
              sc_8,
              deuda_sin_hipoteca,
              deuda_hoy,
              alguna_hipoteca,
              clavesii,
              razon_social,
              giro,
              web,
              fecha_inicio_actividades,
              categoria,
              cant_trabajadores,
              proveedores_comuna,
              tramo_id,
              region_id,
              comuna_id,
              pais_id,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${store.state.token}`
              }
            }
          )
            .then((res: any) => {
              resolve(res);
            })
            .catch((error: any) => {
              reject(error.response);
            });
        });
      },
      business_sii(
        clavesii: string,
        empresa_id:number
      ) {
        return new Promise((resolve, reject) => {
          // @ts-ignore
          Axios.post(
            `${Configuration.api.base}/clave/${empresa_id}`,
            {
              // @ts-ignore
              user_id: store.state.user.id,
              clavesii,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${store.state.token}`
              }
            }
          )
            .then((res: any) => {
              resolve(res.data.data);
            })
            .catch((error: any) => {
              reject(error.response);
            });
        });
      },
      request(
        empresa_id: string,
        motivo: string,
        monto: string,
        plazo: number,
        sc_7: number,
        tramo_id:number,
        destino?: string,
        sc_evaluacion_id?: any,
        monto_ideal?:string,
        me_permitira?:string,
      ) {
        return new Promise((resolve, reject) => {
          let payload: any = {
            // @ts-ignore
            user_id: store.state.user.id,
            empresa_id,
            motivo,
            monto,
            plazo,
            sc_7,
            tramo_id,
            sc_evaluacion_id,
            destino,
            monto_ideal,
            me_permitira
          };
          Axios.post(`${Configuration.api.base}/solicitud/credito_sg`, payload, {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          })
            .then(res => {
              resolve(res.data.data);
            })
            .catch(error => {
              reject(error.response.data);
            });
        });
      },
      requestanglo(
        empresa_id: string,
        motivo: string,
        monto: string,
        plazo: number,
        sc_7: number,
        tramo_id:number,
        destino?: string,
        monto_ideal?:string,
        me_permitira?:string,
      ) {
        return new Promise((resolve, reject) => {
          let payload: any = {
            // @ts-ignore
            user_id: store.state.user.id,
            empresa_id,
            motivo,
            monto,
            plazo,
            sc_7,
            tramo_id,
            destino,
            monto_ideal,
            me_permitira
          };
          Axios.post(`${Configuration.api.base}/solicitud/credito_sg`, payload, {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          })
            .then(res => {
              resolve(res.data.data);
            })
            .catch(error => {
              reject(error.response.data);
            });
        });
      },
      owners(owners: any, empresa_id:any,sc_evaluacion_id?:any) {
        return new Promise((resolve, reject) => {
          Axios.post(`${Configuration.api.base}/empresa_dueno`, {
            owners,
            empresa_id,
            sc_evaluacion_id
          }, {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          })
            .then(res => {
              resolve(res.data.data);
            })
            .catch(error => {
              reject(error.response.data);
            });
        });
      },
      meetYou(
        first: string,
        second: string,
        third: string,
        eighth: string,
        nineth: string,
        twelfth?: string,
        fourth?: string,
        fifth?: string,
        seventh?: string,
        tenth?: string,
        eleventh?: string
      ) {
        return new Promise((resolve, reject) => {
          // @ts-ignore
          Axios.post(`${Configuration.api.base}/preguntas/accion`, {
            // @ts-ignore
            user_id: store.state.user.id,
            first: first,
            second: second,
            third: third,
            fourth: fourth,
            fifth: fifth,
            seventh: seventh,
            eighth: eighth,
            nineth: nineth,
            tenth: tenth,
            eleventh: eleventh,
            twelfth: twelfth
          },{
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          })
            .then(res => {
              resolve(res.data.data);
            })
            .catch(error => {
              reject(error);
            });
        });
      },
      carpeta(folder: any, empresa: any) {
        return new Promise((resolve, reject) => {
          let payload: any = {
            carpeta: folder
          }
          // @ts-ignore
          Axios.post(`${Configuration.api.base}/carpeta/${empresa}`, payload, {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          })
            .then((res: any) => {
              resolve(res.data.data);
            })
            .catch((error: any) => {
              reject(error.response);
            });
        });
      },
      submitQuestions(
        first: string,
        second: string,
        third: string,
        fourth: string,
        fifth: string,
        seventh: string,
        eighth: string,
        nineth: string,
        tenth: string,
        eleventh: string
      ) {
        return new Promise((resolve, reject) => {
          // @ts-ignore
          Axios.post(`${Configuration.api.base}/preguntas/accion`, {
            // @ts-ignore
            user_id: store.state.user.id,
            first: first,
            second: second,
            third: third,
            fourth: fourth,
            fifth: fifth,
            seventh: seventh,
            eighth: eighth,
            nineth: nineth,
            tenth: tenth,
            eleventh: eleventh
          })
            .then(res => {
              resolve(res.data.data);
            })
            .catch(error => {
              reject(error);
            });
        });
      },postReferidos(referidos:any,empresaid:any){
        return new Promise((resolve,reject)=>{
          Axios.post(`${Configuration.api.base}/sc_referidos/${empresaid}`,referidos,{
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }).then(res=>{
            resolve(res)
          }).catch(err =>{
            reject(err)
          })
        })
      },
      referido(codigo_enlace:any,
        rut:any,
        t_relacion_id: any,
        sc_tiempo_id: any,
        familiar: any,
        sc_13: any,
        sc_14: any
        ){
        return new Promise((resolve,reject)=>{
          Axios.put(`${Configuration.api.base}/referido/${codigo_enlace}`,{
            rut,
            t_relacion_id,
            sc_tiempo_id,
            familiar,
            sc_13,
            sc_14
          },{
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }).then(res=>{
            resolve(res)
          }).catch(err =>{
            reject(err)
          })
      })
    },
    getReferidos(id: any){
      return new Promise((resolve,reject)=>{
        Axios.get(`${Configuration.api.base}/referido/datos/${id}`,{
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }).then(res=>{
          resolve(res)
        }).catch(err =>{
          reject(err)
        })

      })
    },
    ultimopaso(empresaid:any){
        return new Promise((resolve,reject)=>{
          Axios.get(`${Configuration.api.base}/ultimoPaso/${empresaid}`,{
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }).then(res=>{
            resolve(res)
          }).catch(err =>{
            reject(err)
          })
  
        })
  
      },
      async Is_Referidos(id: any){
        const referidos =await Axios.get(`${Configuration.api.base}/verificar_referidos/${id}`,
        { 
          headers: { 
            Authorization: `Bearer ${store.state.token}`
          } 
        })
        return referidos.data
      },
      async qconocerte_anglo(){
        const preguntas =await Axios.get(`${Configuration.api.base}/scoring/preguntas/2/3.5`,
        { 
          headers: { 
            Authorization: `Bearer ${store.state.token}`
          } 
        })
        return preguntas.data
      },
      async qconocerte_scoring(){
        const preguntas =await Axios.get(`${Configuration.api.base}/scoring/preguntas/1/2`,
        { 
          headers: { 
            Authorization: `Bearer ${store.state.token}`
          } 
        })
        return preguntas.data
      },
      async guardar_anglo(respuestas:any){
        const guardar_anglo =await Axios.post(`${Configuration.api.base}/scoring/evaluacion/generar`,
        
          respuestas
        ,
        { 
          headers: { 
            Authorization: `Bearer ${store.state.token}`
          } 
        })
        return guardar_anglo.data
      }
    }
  },
  actividad:{
    organiza:{
      guardarlistado(answers:any){
        return new Promise((resolve, reject)=>{
          Axios.post(`${Configuration.api.base}/cta/cta11`, answers, {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }).then(res=>{
            resolve(res)
          }).catch(error => {reject(error)})
        })
      },
      listadosituacion(answers:any){
        return new Promise((resolve,reject)=>{
          Axios.post(`${Configuration.api.base}/cta/cta12`, answers, {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }).then(res=>{
            resolve(res)
          }).catch(error => {reject(error)})
        })
      },guardarfirma(answers:any){
        return new Promise((resolve,reject)=>{
          Axios.post(`${Configuration.api.base}/cta/cta13`, answers, {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }).then(res=>{
            resolve(res)
          }).catch(error => {reject(error)})
        })
      },guardarfinanzas(answers:any){
        return new Promise((resolve,reject)=>{
          Axios.post(`${Configuration.api.base}/cta/cta14`, answers, {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }).then(res=>{
            resolve(res)
          }).catch(error => {reject(error)})
        })
      }
    },costos:{
      comprension(answers:any){
        return new Promise((resolve,reject)=>{
          Axios.post(`${Configuration.api.base}/cta/cta21`, answers, {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }).then(res=>{
            resolve(res)
          }).catch(error => reject(error))
        })
      },dejastedevender(answers:any){
        return new Promise((resolve,reject)=>{
          Axios.post(`${Configuration.api.base}/cta/cta23`, answers, {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }).then(res=>{
            resolve(res)
          }).catch(error => reject(error))
        })
      },subirimg(data:any){
        return new Promise((resolve,reject)=>{
          Axios.post(`${Configuration.api.base}/cta/cta22`, 
             { 
               data
             },{
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }).then(res=>{
            resolve(res)
          }).catch(error => reject(error))
        })
      },prodestrella(answers:any){
        return new Promise((resolve,reject)=>{
          Axios.post(`${Configuration.api.base}/cta/cta24`, answers, {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }).then(res=>{
            resolve(res)
          }).catch(error => reject(error))
        })
      }
    },metascortoplazo:{
      objetivosmes(answers:any){
        return new Promise((resolve,reject)=>{
          Axios.post(`${Configuration.api.base}/cta/cta31`, answers, {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }).then(res=>{
            resolve(res)
          }).catch(error => reject(error))
        })
      },objetivosanio(answers:any){
        return new Promise((resolve,reject)=>{
          Axios.post(`${Configuration.api.base}/cta/cta32`, answers, {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }).then(res=>{
            resolve(res)
          }).catch(error => reject(error))
        })
      },objetivobussiness(answers:any){
        return new Promise((resolve,reject)=>{
          Axios.post(`${Configuration.api.base}/cta/cta34`, answers, {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }).then(res=>{
            resolve(res)
          }).catch(error => reject(error))
        })
      }
    },gestionadeuda:{
      calcular(answers:any){
        return new Promise((resolve,reject)=>{
          Axios.post(`${Configuration.api.base}/cta/cta41`, answers, {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }).then(res=>{
            resolve(res)
          }).catch(error => reject(error))
        })
      },capacidadpago(answers:any){
        return new Promise((resolve,reject)=>{
          Axios.post(`${Configuration.api.base}/cta/cta42`, answers, {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }).then(res=>{
            resolve(res)
          }).catch(error => reject(error))
        })
      },vendescredito(answers:any){
        return new Promise((resolve,reject)=>{
          Axios.post(`${Configuration.api.base}/cta/cta43`, answers, {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }).then(res=>{
            resolve(res)
          }).catch(error => reject(error))
        })
      }
    },infoactividades:{
      actividadesrealizadas(id:any){
        return new Promise((resolve, reject) => {
          // @ts-ignore
          Axios.get(`${Configuration.api.base}/cta/advance/${id}`,{ headers: {
            Authorization: `Bearer ${store.state.token}`
          }
          })
            .then(res => {
              resolve(res);
            })
            .catch(error => {
              reject(null);
            });
        });
      }
    }
  },
  factoring: {
    getBusiness() {
      //@ts-ignore
        const empresas = Axios.get(`${Configuration.api.base}/empresa/usuario/${store.state.user.id}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }
        )
        return empresas;
    },
    async sumaFacturas(empresa_id:any){
      const sumaFacturas = await Axios.get(`${Configuration.api.base}/suma_facturas_dte/${empresa_id}`,
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      })
      return sumaFacturas.data
    },
    async listarFacturasDTE(empresa_id:any){
      const facturasDte = await Axios.get(`${Configuration.api.base}/listar_facturas_dte/${empresa_id}`,
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      })
      return facturasDte.data
    },
    async listarFacturasConfirming(empresa_id:number){
      const facturasConfirming = await Axios.get(`${Configuration.api.base}/listar_facturas_dte_confirming/${empresa_id}`,
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      })
      return facturasConfirming.data;
    },
    async listarFacturasFactoring(empresa_id:number){
      const facturasFactoring = await Axios.get(`${Configuration.api.base}/listar_facturas_factoring/${empresa_id}`,
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      })
      return facturasFactoring.data;
    },
    async buscarEmpresaNit(nit:number, tipo_documento:number){
      let formData = new FormData();
      formData.append('nit', nit.toString());
      formData.append('tipo_documento', tipo_documento.toString());
      const empresa = await Axios.post(`${Configuration.api.base}/empresa/buscar_por_nit/`,formData,
      {
        headers:{
          Authorization: `Bearer ${store.state.token}`,
        }
      })
      return empresa.data;
    },
    async datosEmpresa(id:number){
      const empresa = await Axios.get(`${Configuration.api.base}/empresa/${id}`,
      {
        headers:{
          Authorization: `Bearer ${store.state.token}`,
        }
      })
      return empresa;
    },

    async actualizardatosEmpresa(payload:any){
      const formData = new FormData();
      Object.entries(payload).forEach(([key, value]) => {
        if (key === 'doc_files') {
          //@ts-ignore
          Object.entries(value).forEach(([fileKey, file]) => {
            if (file instanceof File) {
              formData.append(`doc_files[${fileKey}]`, file);
            }
          });
        } else {
          // Convierte todos los valores a string antes de agregar
          //@ts-ignore
          formData.append(key, value != null ? value.toString() : '');
        }
      });

      // @ts-ignore
      formData.append('user_id', store.state.user.id);
      const empresa = await Axios.post(`${Configuration.api.base}/empresa/${payload.id}?_method=PUT`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${store.state.token}`,
        },
      });

      return empresa.data;
    },
    
  //factoring
  //
  //confirming

    ///sii chile

    sii(businesSelected_id:any,password:any,c_password:any){
      return new Promise((resolve,reject)=>{
        Axios.post(`${Configuration.api.base}/sii-configurations/${businesSelected_id}/password`,{
          password: password,
          password_confirmation: c_password,
        },{
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        })
        .then((res)=>{
          resolve(res)
        })
        .catch((err)=>{
          reject(err)
        })
      })
    },
    certificado_sii(businesSelected_id:any,archivo:any,c_password:any){
      return new Promise((resolve,reject)=>{
        let formData = new FormData();
        archivo.forEach((f:any) => {
          formData.append('original', f);
        });
        formData.append('password', c_password);
        Axios.post(`${Configuration.api.base}/empresas/${businesSelected_id}/certificadosDigitales/upload`,
         formData
        ,
          { 
            headers: { 
              Authorization: `Bearer ${store.state.token}`,
              'Content-Type': 'multipart/form-data'
            } 
          }
        )
        .then((res)=>{
          resolve(res)
        })
        .catch((err)=>{
          reject(err)
        })
      })
    },
    factureUploads(businesSelected_id:any,archivo:any){
      return new Promise((resolve,reject)=>{
        let formData = new FormData();
        archivo.forEach((el: any)=>{
          formData.append('xml[]',el)
        })
        Axios.post(`${Configuration.api.base}/empresas/${businesSelected_id}/facturasSubidas/upload`,
        formData
        ,
          { 
            headers: { 
              Authorization: `Bearer ${store.state.token}`,
              'Content-Type': 'multipart/form-data'

            } 
          }
        )
        .then((res)=>{
          resolve(res)
        })
        .catch((err)=>{
          reject(err.response)
        })
      })
    },
    cederFacture(businesSelected_id:any,id_factura:any){
      return new Promise((resolve,reject)=>{
        Axios.post(`${Configuration.api.base}/empresas/${businesSelected_id}/facturasSubidas/${id_factura}/ceder`, {},
        { 
          headers: { 
            Authorization: `Bearer ${store.state.token}`
          } 
        }
        ).then((res)=>{
          resolve(res)
        }).catch((err)=>{
          reject(err)
        })
      })
    },
    async cederFacturasMasivo(businesSelected_id:any,facturas:any){
      const ceder = await Axios.post(`${Configuration.api.base}/ceder_masivo/${businesSelected_id}`, 
        {facturas},
        { 
          headers: { 
            Authorization: `Bearer ${store.state.token}`
          } 
        }
      );
      return ceder.data;
    },
    async listarFacturasParaCeder(businesSelected_id:any){
      const listado_faturas = await Axios.get(`${Configuration.api.base}/empresas/${businesSelected_id}/facturasSubidas/ceder`, 
        { 
          headers: { 
            Authorization: `Bearer ${store.state.token}`
          } 
        }
      );
      return listado_faturas.data;
    },
    listarFacturasCargadas(businesSelected_id:any){
      return new Promise((resolve,reject)=>{
        Axios.get(`${Configuration.api.base}/empresas/${businesSelected_id}/facturasSubidas`,{
           headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }).then((res)=>{
          resolve(res)
        })
        .catch((err)=>{
          reject(err)
        })
      })
    },
    listarFacturasCargadasFiltradas(businesSelected_id:any){
      return new Promise((resolve,reject)=>{
        Axios.get(`${Configuration.api.base}/empresas/${businesSelected_id}/facturasSubidas/filtradas`,{
           headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }).then((res)=>{
          resolve(res)
        })
        .catch((err)=>{
          reject(err)
        })
      })
    },
    cargarFactura(businesSelected_id:any,formData:any){
      return new Promise((resolve,reject)=>{
        Axios.post(`${Configuration.api.base}/empresas/${businesSelected_id}/facturasSubidas/upload`, formData,
        { headers: {
          Authorization: `Bearer ${store.state.token}`,
          "X-Requested-With": "XMLHttpRequest",
        }, }
        ).then((res)=>{
          resolve(res)
        }).catch((err)=>{
          reject(err)
        })
      })
    },
    carga_masiva_facturas_sin_proyecto(formData:any){
      return new Promise((resolve,reject)=>{
        Axios.post(`${Configuration.api.base}/carga_masiva_facturas_sin_proyecto`, formData,
        { headers: {
          Authorization: `Bearer ${store.state.token}`,
        }, }
        ).then((res)=>{
          resolve(res)
        }).catch((err)=>{
          reject(err)
        })
      })
    },
    sincronizar_emitidos(rut:any){
     return new Promise((resolve,reject)=>{
      Axios.get(`${Configuration.api.base}/sii/${rut}/sincronizar_emitidos`,{
        headers: {
         Authorization: `Bearer ${store.state.token}`
       }
      }).then((res)=>{
        resolve(res)
      })
      .catch((err)=>{
        reject(err)
      })
     })
    },
    async lista_parametros_cotizacion(){
      const parametros = await Axios.get(`${Configuration.api.base}/lista_parametros_cotizacion`,{
          headers: {
           Authorization: `Bearer ${store.state.token}`
         }
        })
      return parametros.data;
    },
    async date_parametros_onboarding(){
      const dates = await Axios.get(`${Configuration.api.base}/cotizacion/params/onboarding`,{
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
      return dates.data;

    },
    crear_cotizacion(cotizacion:any){
      return new Promise((resolve,reject)=>{
        Axios.post(`${Configuration.api.base}/crear_cotizacion`, 
          cotizacion,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
        ).then((res)=>{
          resolve(res)
        }).catch((err)=>{
          reject(err)
        })
      })
    },
    crear_simulacion(cotizacion:any){
      return new Promise((resolve,reject)=>{
        Axios.post(`${Configuration.api.base}/crear_simulacion`, 
          cotizacion,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
        ).then((res)=>{
          resolve(res)
        }).catch((err)=>{
          reject(err)
        })
      })
    },
    async mis_cotizaciones(empresa_id:any){
      const mis_cotizaciones = await Axios.get(`${Configuration.api.base}/mis_cotizaciones/${empresa_id}`,{
        headers: {
        Authorization: `Bearer ${store.state.token}`
      }
      })
      return mis_cotizaciones.data
    },
    async get_notificaciones(){
      const info_user_notificacion = await Axios.get(`${Configuration.api.base}/info_user_notificacion`,
      {   
        headers :{
          Authorization: `Bearer ${store.state.token}`
        }
      })
      return info_user_notificacion;
    },
    async get_cuentas(id_empresa:any){
      const listar_mis_cuentas = await Axios.get(`${Configuration.api.base}/listar_mis_cuentas`, 
      {
        params:{
          empresa_id:id_empresa
        },
        headers :{
          Authorization: `Bearer ${store.state.token}`
        }
      })
      return listar_mis_cuentas.data;
    },
    async listarmiscuentas(user_id:any){
      const listar_mis_cuentas = await Axios.get(`${Configuration.api.base}/listar_mis_cuentas_por_usuario`,
      {
        params:{
          user_id
        },
        headers :{
          Authorization: `Bearer ${store.state.token}`
        }
      })
      return listar_mis_cuentas.data;
    },
    async get_cuenta_sii(dni:any){
       const cuenta_sii = await Axios.get(`${Configuration.api.base}/obtener_cuenta_sii`,
      { params:{
          rut:dni
        },
        headers :{
          Authorization: `Bearer ${store.state.token}`
        }
      })
      return cuenta_sii;
    },
    async get_cuenta_previred(dni:any){
      const cuenta_previred = await Axios.get(`${Configuration.api.base}/obtener_cuenta_previred`,
     {  
       params:{
        rut:dni
      },
       headers :{
         Authorization: `Bearer ${store.state.token}`
       }
     })
     return cuenta_previred;
    },
    async get_cuenta_tgr(dni:any){
      const obtener_cuenta_tgr = await Axios.get(`${Configuration.api.base}/obtener_cuenta_tgr`,
      { 
        params:{
        rut:dni
      },
        headers :{
          Authorization: `Bearer ${store.state.token}`
        }
      })
      return obtener_cuenta_tgr;
    },
    async guardar_cuenta_tgr(dni:any,clave_tgr:any){
      const guardar_cuenta_tgr = await Axios.post(`${Configuration.api.base}/agregar_cuenta_tgr`,
      {
        "rut":dni,
        "clave": clave_tgr
      },
      {
        headers: {
        Authorization: `Bearer ${store.state.token}`
      }
      })
      return guardar_cuenta_tgr.data
    },
    async guardar_cuenta_previred(dni:any,clave_tgr:any){
      const agregar_cuenta_previred = await Axios.post(`${Configuration.api.base}/agregar_cuenta_previred`,
      {
        "rut":dni,
        "clave": clave_tgr
      },
      {
        headers: {
        Authorization: `Bearer ${store.state.token}`
      }
      })
      return agregar_cuenta_previred.data
    },
    async guardar_actualizar_notificacion(mail:any,whatsapp:any,news:any){
      const actualizar_notificacion = await Axios.post(`${Configuration.api.base}/actualizar_notificacion`,
      {
        "whatsapp": whatsapp,
        "news": news,
        "mail": mail
      },
      {
        headers: {
        Authorization: `Bearer ${store.state.token}`
      }
      })
      return actualizar_notificacion.data
    },
    async guardar_cuenta_banco(cuenta:any){
      let formData = new FormData();
      formData.append('banco_id',cuenta.banco_id)
      formData.append('cuenta_tipo_id',cuenta.tipo_id)
      formData.append('numero',cuenta.numero)
      formData.append('empresa_id',cuenta.empresa_id)
      formData.append('alias',cuenta.alias)
      formData.append('archivo',cuenta.documento)
      formData.append('doc_terceros',cuenta.doc_terceros)
      formData.append('tercero',cuenta.tercero)
      formData.append('tipo_documento_id',cuenta.tipo_documento_id)
      formData.append('numero_documento_tercero', cuenta.numero_documento_tercero)
      formData.append('nombre_tercero', cuenta.nombre_tercero)
      formData.append('ciiu_id', cuenta.ciiu)

      const cuenta_banco = await Axios.post(`${Configuration.api.base}/crear_cuenta_bancaria_usuario`,
        formData,
      {
        headers: {
        Authorization: `Bearer ${store.state.token}`
      }
      })
      return cuenta_banco.data
    }, 
    async actualizar_cuenta_bancaria(cuenta:any){
        const actualizar_cuenta_bancaria_usuario = await Axios.put(`${Configuration.api.base}/actualizar_cuenta_bancaria_usuario`,
        {
          "cuenta_id": cuenta.cuenta_id,
          "banco_id": cuenta.banco_id,
          "cuenta_tipo_id": cuenta.tipo_id,
          "numero": cuenta.numero,
          "empresa_id": cuenta.empresa_id,
          "alias": cuenta.alias
        },
        {
          headers: {
          Authorization: `Bearer ${store.state.token}`
        }
        })
        return actualizar_cuenta_bancaria_usuario.data
    },
    async factura_subir_pdf(empresa_id:any,id_factura:any,file_pdf:any){
      let formData = new FormData();
      formData.append('archivo',file_pdf)
      formData.append('id',id_factura)
      const pdf = await Axios.post(`${Configuration.api.base}/empresas/${empresa_id}/facturasSubidas/subir_respaldo_factura`,
      formData,
      { 
        headers: { 
          Authorization: `Bearer ${store.state.token}`,
          'Content-Type': 'multipart/form-data'
        } 
      })
      return pdf.data
    },
    async subir_xml_factura(id_factura:any,file_xml:any){
      let formData = new FormData();
      formData.append('archivo',file_xml)
      formData.append('factura_id',id_factura)
      const xml = await Axios.post(`${Configuration.api.base}/subir_xml_factura`,
      formData,
      { 
        headers: { 
          Authorization: `Bearer ${store.state.token}`,
          'Content-Type': 'multipart/form-data'
        } 
      })
      return xml.data
    },
    
    async actualizar_estados_factura(empresa_id:any,id_factura:any,id_estado:any){
      const actualizar_estados_factura = await Axios.post(`${Configuration.api.base}/empresas/${empresa_id}/facturasSubidas/actualizar_estado_factura`,
      {
        id:id_factura,
        id_estado
      },
      { 
        headers: { 
          Authorization: `Bearer ${store.state.token}`
        } 
      })
      return actualizar_estados_factura.data
    },
    async actualizarFechaVencimiento(empresa_id:any,facturas:any){
      const actualizar_fecha_vencimiento = await Axios.post(`${Configuration.api.base}/empresas/${empresa_id}/facturasSubidas/actualizar_fecha_vencimiento`,
      {
        facturas
      },
      { 
        headers: { 
          Authorization: `Bearer ${store.state.token}`
        } 
      })
      return actualizar_fecha_vencimiento.data
    },
    async ultimoPasoEmpresa(empresa_id:any,origen:any){
      const {data} = await Axios.get(`${Configuration.api.base}/track/onboarding/${empresa_id}/${origen}`,
      {
        headers: { 
          Authorization: `Bearer ${store.state.token}`
        } 
      })
      return data;
    },
    async tranckingOnboarding(origen:any,empresa_id:any,ip_address:any,variable:any,info?:any,facturas?:any){
      const tranckingOnboarding = await Axios.post(`${Configuration.api.base}/track/onboarding`,
      {
        origen,
        empresa_id,
        ip_address,
        variable,
        info,
        facturas
      },
      { 
        headers: { 
          Authorization: `Bearer ${store.state.token}`
        } 
      })
      return tranckingOnboarding.data
    },
    async listar_facturas_onboarding(empresa_id:any){
      const {data} = await Axios.get(`${Configuration.api.base}/listar_facturas_onboarding/${empresa_id}`,
      {
        headers: { 
          Authorization: `Bearer ${store.state.token}`
        } 
      })
      return data;
    },
    async obtenerCertificado(empresa_id:any){
      const data = await Axios.get(`${Configuration.api.base}/empresas/${empresa_id}/certificadoDigital`,
      {
        headers: { Authorization : `Bearer ${store.state.token}`}
      })
      return data

    }, 
    async descargarPdf(empresa_id:any,documento_id:any) {
      const data = await Axios.get(`${Configuration.api.base}/descargar_pdf/${empresa_id}/${documento_id}`,
      {
        headers: { Authorization : `Bearer ${store.state.token}`},
        responseType: 'blob'
      })
      return data
    },
    async sii_vinculado(empresa_id:any){
      const data = await Axios.get(`${Configuration.api.base}/empresas/${empresa_id}/sii`,
      {
        headers: { Authorization : `Bearer ${store.state.token}`},
      })
      return data.data
    },
    async simularCotizacion(simulacion:any){
      const simular_cotizacion =await Axios.post(`${Configuration.api.base}/simular_cotizacion_onboarding`,
        simulacion,
      { 
        headers: { 
          Authorization: `Bearer ${store.state.token}`
        } 
      })
      return simular_cotizacion.data
    },
    async subir_respaldo_cotizacion(formData: any){
      const respaldo = await Axios.post(`${Configuration.api.base}/subir_respaldo_cotizacion`, 
       formData,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
            'Content-Type': 'multipart/form-data'
          }
        })
      return respaldo.data
    },
    async solicitar_pago_excedente(formData:any){
      const pago_excendente = await Axios.post(`${Configuration.api.base}/operacion/factoring/excedentes`,
      formData
      ,
       {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
          'Content-Type': 'multipart/form-data'
        }
       })
       return pago_excendente.data
    },

   
    async datosResumenEmpresa(empresa_id:any){
      var formData = new FormData()
      formData.append("empresa_id",empresa_id);
      const data_empresa = await Axios.post(`${Configuration.api.base}/data_empresa`,
      formData
      ,
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      })
      return data_empresa.data;
    },

   
  }, 
  async queHacemos(){
    const info = await Axios.get(`${Configuration.api.base}/listado_que_hacemos`);

    return info.data;
  },
  getPasswordRules(){
    return Axios.get(`${Configuration.api.base}/password_rules`, {
      headers: {
        Authorization: `Bearer ${store.state.token}`,
      }
    });
  },

  changeTutorialVideo(user_id:string){
    const formData = new FormData();
    formData.append('id', user_id);
    formData.append('tutorial', '1');
    return Axios.post(`${Configuration.api.base}/usuario/tutorial`, formData, {
      headers: {
        Authorization: `Bearer ${store.state.token}`,
      }
    })
  },

  buscoFactoring(user_id:string, form:any){
    const formData = new FormData();
    formData.append('id', user_id);
    formData.append('nombre', form.nombre);
    formData.append('nit', form.nit);
    formData.append('empresa_id', form.businessSelected);
    formData.append('monto', form.monto);
    formData.append('plazo', form.plazo);
    formData.append('periodicidad', form.periodicidad);
    formData.append('sitio_origen', "1");
    formData.append('user_string', "");
    formData.append('empresa_string', "");
    return Axios.post(`${Configuration.api.base}/registrar_busco_factoring`, formData, {
      headers: {
        Authorization: `Bearer ${store.state.token}`,
      }
    })
  },
  getEmpresas(user_id:string) {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/user_empresas/${user_id}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  async obtenerPlazoFactura(factura_id:number) {
    try {
      const formData = new FormData();
      formData.append('factura_id', factura_id.toString());
  
      const response = await Axios.post(`${Configuration.api.base}/obtener_plazo_factura`, formData, {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      });
  
      return response.data;  
    } catch (error) {
      throw error;  
    }
  },
  getTiposProductos(){
    return Axios.get(`${Configuration.api.base}/obtener_productos`, {
      headers: {
        Authorization: `Bearer ${store.state.token}`,
      }
    });
  },

  getRegiones(){
    return Axios.get(`${Configuration.api.base}/obtener_regiones`, {
      headers: {
        Authorization: `Bearer ${store.state.token}`,
      }
    });
  },

  getDepartamentos(){
    return Axios.get(`${Configuration.api.base}/obtener_departamentos`, {
      headers: {
        Authorization: `Bearer ${store.state.token}`,
      }
    });
  },

  getMunicipios(departamento:number){
    return Axios.get(`${Configuration.api.base}/obtener_municipios/${departamento}`, {
      headers: {
        Authorization: `Bearer ${store.state.token}`,
      }
    });
  },

  getCiius(){
    return Axios.get(`${Configuration.api.base}/obtener_ciius`, {
      headers: {
        Authorization: `Bearer ${store.state.token}`,
      }
    });
  },

  getVolumenesEmpresas(){
    return Axios.get(`${Configuration.api.base}/obtener_volumenes_empresas`, {
      headers: {
        Authorization: `Bearer ${store.state.token}`,
      }
    });
  },

  getTipoSociedades(){
    return Axios.get(`${Configuration.api.base}/obtener_tipo_sociedades`, {
      headers: {
        Authorization: `Bearer ${store.state.token}`,
      }
    });
  },

  getProductosActivosEmpresa(empresa_id:number){
    return Axios.get(`${Configuration.api.base}/productos/${empresa_id}`, {
      headers: {
        Authorization: `Bearer ${store.state.token}`,
      }
    });
  },
  getUsers() {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.base}/usuario/control_list/${store.state.user.id}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },

  async controlAccount(user_id:string) {
    try {
      const formData = new FormData();
      formData.append('user_id', user_id);
  
      const response = await Axios.post(`${Configuration.api.base}/usuario/control_account`, formData, {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      });
  
      return response.data;
    } catch (error) {
      throw error;  
    }
  },
  generate2MFA(user_id:string){
    const formData = new FormData();
    formData.append('user_id', user_id);
    return Axios.post(`${Configuration.api.base}/generate_2fa_secret`, formData,{
      headers: {
        Authorization: `Bearer ${store.state.token}`,
      }
    });
  },

  enable2MFA(verify_code:string){
    const formData = new FormData();
    formData.append('verify_code', verify_code);

    return Axios.post(`${Configuration.api.base}/enable2fa`, formData,{
      headers: {
        Authorization: `Bearer ${store.state.token}`,
      }
    });
  },
  
  disable2MFA(user_id:string){
    const formData = new FormData();
    formData.append('user_id', user_id);

    return Axios.post(`${Configuration.api.base}/disable2FA`, formData,{
      headers: {
        Authorization: `Bearer ${store.state.token}`,
      }
    });
  },


  async obtenerCupoFactoring(empresa_id:number) {
    try {
      const formData = new FormData();
      formData.append('empresa_id', empresa_id.toString());
  
      const response = await Axios.post(`${Configuration.api.base}/obtener_cupos_factoring`, formData, {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      });
  
      return response.data;  
    } catch (error) {
      throw error;  
    }
  },

  privacityCheck(user_id:string){
    const formData = new FormData();
    formData.append('id', user_id);
    return Axios.post(`${Configuration.api.base}/usuario/privacityCheck`, formData, {
      headers: {
        Authorization: `Bearer ${store.state.token}`,
      }
    })
  },
  
  async getTokenLiquitech(empresa_id:number) {
    try {
      const formData = new FormData();
      formData.append('empresa_id', empresa_id.toString());
  
      const response = await Axios.post(`${Configuration.api.base}/consulta_documentos`, formData, {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      });
  
      return response.data;  
    } catch (error) {
      throw error;  
    }
  },

  async generatePDF(payload:any){
    const formData = new FormData();
    formData.append('payload', JSON.stringify(payload));

    const response = await Axios.post(`${Configuration.api.base}/pdf/generate`, formData, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${store.state.token}`,
        Accept: 'application/pdf',
      }
    });

    return response;
  },
  async getObtenerFechasCalendario() {
    try {  
      const response = await Axios.get(`${Configuration.api.base}/obtener_plazos_disponibles`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      });
  
      return response.data;  
    } catch (error) {
      throw error;  
    }
  },
  async getRoles(){
    try {  
      const response = await Axios.get(`${Configuration.api.base}/obtener_roles`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      });
  
      return response.data;  
    } catch (error) {
      throw error;  
    }
  },
  async getUsersByEmpresa(empresa_id:number) {
    try {
      const formData = new FormData();
      formData.append('empresa_id', empresa_id.toString());
      
      const response = await Axios.post(`${Configuration.api.base}/obtener_relaciones`, formData, {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async editarRoleByEmpresa(payload: any){
    try {
      const { empresa_id, role_id, user_id } = payload;
      const formData = new FormData();
      formData.append('empresa_id', empresa_id);
      formData.append('user_id', user_id);
      formData.append('role_id', role_id);
      
      const response = await Axios.post(`${Configuration.api.base}/asociar_rol`, formData, {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async cambiarEstadoCotizacion(payload: any) {
    const { cotizacion_id, estado } = payload;
    const formData = new FormData();
    formData.append('cotizacion_id', cotizacion_id);
    formData.append('estado_id', estado);

    try {
      const response = await Axios.post(`${Configuration.api.base}/cambiar_estado_cotizacion`, formData, {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      });

      return response.data;

    } catch (error) {
      let message = 'Ocurrió un error al cambiar el estado.';
      let status = 500;

      //@ts-ignore
      if (error && error.response) {
        //@ts-ignore
        if (error.response.data && error.response.data.message) {
          //@ts-ignore
          message = error.response.data.message;
        }
        //@ts-ignore
        if (error.response.status) {
          //@ts-ignore
          status = error.response.status;
        }
      }

      const customError: any = new Error(message);
      customError.status = status;
      throw customError;

    }
  },
  async resimularCotizacion(payload: any) {
    const { operacion_id } = payload;
    const formData = new FormData();
    formData.append('operacion_id', operacion_id);

    try {
      const response = await Axios.post(`${Configuration.api.base}/resimular_cotizacion_onboarding`, formData, {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      });

      return response.data;

    } catch (error) {
      let message = 'Ocurrió un error al resimular la operación.';
      let status = 500;

      //@ts-ignore
      if (error && error.response) {
        //@ts-ignore
        if (error.response.data && error.response.data.message) {
          //@ts-ignore
          message = error.response.data.message;
        }
        //@ts-ignore
        if (error.response.status) {
          //@ts-ignore
          status = error.response.status;
        }
      }

      const customError: any = new Error(message);
      customError.status = status;
      throw customError;

    }
  },

  async testIris() {
    try {
      const formData = new FormData();
      formData.append('test', 'test');
      
      const response = await Axios.post(`${Configuration.api.base}/test-iris`, formData, {
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getDocumentTypes() {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/documentos/tipos`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getDocumentosByEmpresa(empresa_id:number) {
    const formData = new FormData();
    formData.append('empresa_id', empresa_id.toString());
    return new Promise((resolve, reject) => {
      Axios.post(`${Configuration.api.base}/empresa/archivos`, formData,{
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
      .then(res => {
        resolve(res.data.data);
      })
      .catch(error => {
        reject(null);
      });
    });
  },
  async downloadArchivoByID(id:string){
    const formData = new FormData();
    formData.append('id', id);

    const response = await Axios.post(`${Configuration.api.base}/empresa/descargar_archivo`, formData, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${store.state.token}`,
        Accept: 'application/pdf',
      }
    });

    return response;
  },
  async uploadFileByID(file:File, file_id: string){
    const formData = new FormData();
    formData.append('archivo', file);
    formData.append('archivo_id', file_id);

    const response = await Axios.post(`${Configuration.api.base}/empresa/actualizar_archivo`, formData, {
      headers: {
        Authorization: `Bearer ${store.state.token}`,
        'Content-Type': 'multipart/form-data'
      }
    });

    return response.data;
  },

  async obtenerAplicacionPagos(empresa_id: number){
    const response = await Axios.get(`${Configuration.api.base}/reporte/estado_facturas/${empresa_id}`, {
      headers: {
        Authorization: `Bearer ${store.state.token}`
      }
    });

    return response.data;
  },
  async obtenerFacturaDetalle(id: string){
    const response = await Axios.get(`${Configuration.api.base}/reporte/detalle_pagos/${id}`, {
      headers: {
        Authorization: `Bearer ${store.state.token}`
      }
    });

    return response.data;
  },
  async obtenerRemanentesDisponibles(empresa_id: string){
    const formData = new FormData();
    formData.append('empresa_id', empresa_id);

    const response = await Axios.post(`${Configuration.api.base}/reporte/remanentes_disponibles`, formData, {
      headers: {
        Authorization: `Bearer ${store.state.token}`
      }
    });

    return response.data;
  },
  async obtenerRemanentesAplicados(empresa_id: string){
    const formData = new FormData();
    formData.append('empresa_id', empresa_id);

    const response = await Axios.post(`${Configuration.api.base}/reporte/remanentes_aplicados`, formData, {
      headers: {
        Authorization: `Bearer ${store.state.token}`
      }
    });

    return response.data;
  },

};
